import { ValidatedForm } from "components/forms";
import React from "react";
import { Col, Row } from "design-react-kit";
import { TitoliProfessionali60CFU } from "./enroll60CFU/TitoliProfessionali60CFU";
import { enrollmentService, networkErrorHelper, payloadBuilder } from "libs";
import ReactHtmlParser from "react-html-parser";
import { ENROLLMENT_STEPS } from "const";

export class EnrollFillForm60CFUStep3 extends ValidatedForm {
  state = {
    _formRefOther: React.createRef(),
    loading: false,
    defaultValues: {},
    validationSummary: "",
    currentCompetitionClass:
      this.props.enrollData.pluginConfig.competitionClass || "",
    defaultPayloads: {},
  };

  componentDidMount() {
    const { idEnrollment } = this.props.enrollData;
    this.loadRemoteQualifications(idEnrollment);
  }

  onSubmit = async () => {
    let validationList = [];
    let isValid = true;
    let qualifications = [];
    this.payload = payloadBuilder(this.state);

    //--- titleStep3 ---
    const { _formRefOther } = this.state;

    // titoli professionali
    if (_formRefOther) {
      const checkValidation = _formRefOther.current.checkValidation();

      if (!checkValidation) {
        validationList.push("Verificare i dati evidenziati in rosso.");
        isValid = false;
      } else {
        if (!_formRefOther.current.onSubmit()) {
          validationList.push("Verificare i dati evidenziati in rosso");
          isValid = false;
        } else {
          const payload = _formRefOther.current.getPayload();
          qualifications.push(...payload);
        }
      }
    }

    this.payload.qualifications = qualifications;

    if (isValid) {
      const payloadQualification = {
        idEnrollment: this.props.enrollData.idEnrollment,
        currentStep: ENROLLMENT_STEPS.FILL3,
        qualifications: qualifications,
      };

      try {
        await enrollmentService.updateEnrollmentQualification(
          payloadQualification,
        );

      } catch (errors) {
        validationList.push(
          "Errore imprevisto nell'invio dei dati. Se il problema persiste contattare il supporto tecnico.",
        );
        networkErrorHelper.notify(errors);
        isValid = false;
      }
    }

    let validationSummary = "";

    if (validationList.length > 0) {
      validationSummary =
        "<ul><li>" + validationList.join("</li><li>") + "</li></ul>";
    }
    this.setState({ validationSummary });
    return isValid;
  };

  getPayload = () => {
    return this.payload;
  };

  getDefaultPayload = (qualifications) => {
    const defaultPayloads = {
      Title31Item_TitoliProfessonaliLode: [],
      Title31Item_TitoliProfessonali: [],
    };

    qualifications.forEach((q) => {
      const template = q.template;

      if (!defaultPayloads[template]) {
        defaultPayloads[template] = [];
      }

      defaultPayloads[template].push(q);
    });

    //merge TitoliProfessionali with TitoliProfessionaliLode
    defaultPayloads.Title31Item_TitoliProfessonali = [
      ...(defaultPayloads.Title31Item_TitoliProfessonali || []),
      ...(defaultPayloads.Title31Item_TitoliProfessonaliLode || []),
    ];

    return defaultPayloads;
  };

  loadRemoteQualifications = (idEnrollment) => {
    this.setState({ loading: true });

    enrollmentService
      .getEnrollmentQualifications(idEnrollment, "fill3")
      .then(({ data }) => {
        const qualifications = data.payload?.qualifications || [];
        const defaultPayloads = this.getDefaultPayload(qualifications);

        this.setState({
          defaultPayloads,
          loading: false,
        });
      })
      .catch((errors) => {
        this.setState({ loading: false });
        console.error(errors);
        networkErrorHelper.notify(errors);
      });
  };

  //--- ---

  render() {
    const { loading, _formRefOther, validationSummary, defaultPayloads } =
      this.state;
    const { idEnrollment } = this.props.enrollData;
    if (loading) return <></>;

    return (
      <>
        <Row className="mt-2">
          <Col>
            <h6>TITOLI PROFESSIONALI (da dichiarare anche ai fini dell’eventuale riconoscimento)</h6>
            <TitoliProfessionali60CFU
              ref={_formRefOther}
              skipCC={false}
              competitionClass={this.state.currentCompetitionClass}
              defaultPayload={defaultPayloads.Title31Item_TitoliProfessonali}
              idEnrollment={idEnrollment}
            />
          </Col>
        </Row>

        <Row>
          <div className="w-100">
            {validationSummary && (
              <div className="alert alert-danger mt-3" role="alert">
                {ReactHtmlParser(validationSummary)}
              </div>
            )}
          </div>
        </Row>
      </>
    );
  }
}
